import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { cn } from '@/app/utils'
import { AppTextarea } from '@/components/shared/textarea'
import {
  MAX_DESCRIPTION_LENGTH,
  MAX_DESCRIPTION_LENGTH_MESSAGE_FROM
} from '@/utils/constants'

import { CommonRequestFormData } from '../model/schemas'

type Props = {
  className?: string
  title?: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
  inputTestId?: string
  counterTestId?: string
}

const RequestCommentFormBlock: FC<Props> = ({
  className,
  title,
  placeholder,
  required,
  disabled,
  inputTestId,
  counterTestId
}) => {
  const {
    control,
    formState: { errors }
  } = useFormContext<CommonRequestFormData>()

  return (
    <div
      className={cn('form-block-cover p-32 pt-24 lg:p-16 sm:px-0', className)}
    >
      <p className="form-block-title mb-24 md:mb-16 sm:mb-8">{title}</p>
      <Controller
        name="description"
        control={control}
        render={({ field }) => (
          <AppTextarea
            {...field}
            value={field.value ?? ''}
            placeholder={placeholder}
            invalid={Boolean(errors?.description?.message)}
            invalidMessage={errors?.description?.message}
            maxLength={MAX_DESCRIPTION_LENGTH}
            dataTestId={inputTestId}
            counterTestId={counterTestId}
            {...(required && {
              maxLengthMessageFrom: MAX_DESCRIPTION_LENGTH_MESSAGE_FROM
            })}
            className="w-full"
            borderColor="border-grey-20"
            disabled={disabled}
          />
        )}
      />
    </div>
  )
}

export { RequestCommentFormBlock }
